import { Code2 } from 'lucide-react';
import { LIMIT_KEYS, LIMIT_LABELS } from '@/types/licensing';

export default function LimitKeysSection() {
  return (
    <section className="card p-6 space-y-4">
      <div className="flex items-start gap-3">
        <div className="rounded-lg bg-sky-500/10 p-2 text-sky-400">
          <Code2 className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-ink-primary">Limit keys</h2>
          <p className="mt-1 text-sm text-ink-secondary">
            Read-only contract used by plans, add-ons, and effective limits. Adding a new key is a code change in
            <code className="ml-1 text-gold">src/types/licensing.ts</code>.
          </p>
        </div>
      </div>

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        {LIMIT_KEYS.map((key) => (
          <div key={key} className="rounded-lg border border-navy-border bg-navy/30 p-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-ink-muted">{key}</p>
            <p className="mt-1 text-sm text-ink-primary">
              {LIMIT_LABELS[key].label}
              {LIMIT_LABELS[key].unit ? ` (${LIMIT_LABELS[key].unit})` : ''}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
